// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__X6l27","shimmer":"Skeleton_shimmer__cPb2V"};